import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'antd';
import { CandidateListItem } from './candidate-list-item';

export function CandidateList({ items, emptyText, staffingRequest }) {
  return (
    <div className="CandidateList">
      <List
        rowKey="id"
        itemLayout="vertical"
        locale={{ emptyText: emptyText }}
        dataSource={items}
        renderItem={(item) => (
          <CandidateListItem item={item} staffingRequest={staffingRequest} />
        )}
      />
    </div>
  );
}

CandidateList.propTypes = {
  items: PropTypes.array,
  emptyText: PropTypes.string,
  staffingRequest: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
};
